/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    specialEquipmentSubCompanyId: {},
    specialEquipmentEquipmentType: {}
  },
  getters: {
    specialEquipmentSubCompanyId: state => state.specialEquipmentSubCompanyId,
    specialEquipmentEquipmentType: state => state.specialEquipmentEquipmentType
  },
  mutations: {
    specialEquipmentSubCompanyId: (state, data) => {
      state.specialEquipmentSubCompanyId = data
    },
    specialEquipmentEquipmentType: (state, data) => {
      state.specialEquipmentEquipmentType = data
    }
  },
  actions: {
    handleSpecialEquipmentSubCompanyId (specialEquipmentSubCompanyId, data) {
      specialEquipmentSubCompanyId.commit('specialEquipmentSubCompanyId', data)
    },
    handleSpecialEquipmentEquipmentType (specialEquipmentEquipmentType, data) {
      specialEquipmentEquipmentType.commit('specialEquipmentEquipmentType', data)
    }
  }
}
